export const urlGetQuestionKnowledge = '/api/XOrg/Paper/getQuestionKnowledge';
export const urlGetQuestionList = '/api/XOrg/Paper/getImportQuestionList';

import http from 'lib/http';

export interface IKnowledgeList {
  code: string;
  knowledgeList: {
    Id: string;
    KnowledgeName: string;
  }[];
}

export interface IQuestionList {
  code: string;
  list: {
    questionId: string;
    dateCreated: string;
    createrName: string;
    knowledgeId: string;
    KnowledgeName: string;
    questionType: string;
    difficulty: string;
    content: string;
    contentText: string;
    selectContent: Array<string>;
    answerContent: Array<string>;
    questionOrder: string;
    analysis: string;
    checked:boolean;
  }[];
  pagination: {
    pageIndex: string;
    pageSize: string;
    totalCount: string;
  };
}

// 获取知识点列表
export function GetKnowledgeList(courseId: string) {
  return http.post<IKnowledgeList>(urlGetQuestionKnowledge, {
    courseId
  });
}

// 获取题库列表
export function GetImportQuestionList(
  courseId: string,
  knowledgeId?: string,
  queTypevalue?: string,
  diffTypeValue?: string,
  page?: number,
  pageSize?: number
) {
  return http.post<IQuestionList>(urlGetQuestionList, {
    courseId, knowledgeId, queTypevalue, diffTypeValue , page , pageSize
  });
}
